module.exports = __webpack_public_path__ + "img/tuition-tutorial-02.e6e7c760.png";